import { EntityLevel } from '@suntex.fim/enums';
import { PlayerProvider, usePlayer } from '@suntex.fim/player';

import type { CommonLayoutProps } from './CommonLayout';
import { EntityLayoutShell } from './EntityLayoutShell';

export type PlayerLayoutProps = Pick<CommonLayoutProps, 'appVersion'>;

/**
 * Layout wrapper for player-scoped routes (`/player/...`).
 */
export function PlayerLayout(props: Readonly<PlayerLayoutProps>) {
  return (
    <PlayerProvider>
      <_EntityProviderWrapper {...props} />
    </PlayerProvider>
  );
}

function _EntityProviderWrapper(props: Readonly<PlayerLayoutProps>) {
  const player = usePlayer();

  return (
    <EntityLayoutShell
      {...props}
      entityLevel={EntityLevel.Player}
      entityId={player.playerId}
    />
  );
}
